import React from 'react';
import { formatUSDTRaw } from '../utils/helpers';
import '../styles/hero.css';

export default function HeroStats({ totalIncome, boardIncome, directIncome, levelIncome, usdtBalance }) {
  return (
    <div className="hero-card">
      <div className="hero-shimmer"></div>
      <div className="hero-glow"></div>
      <div className="hero-content">
        <div className="hero-label">Total Income Earned</div>
        <div className="hero-amount">
          <span className="hero-currency">$</span>
          <span className="hero-value">{formatUSDTRaw(totalIncome)}</span>
        </div>
        <div className="hero-unit-tag">USDT</div>
        <div className="hero-breakdown">
          <div className="hero-stat">
            <div className="hero-stat-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>
            </div>
            <span className="hero-stat-value">${formatUSDTRaw(boardIncome)}</span>
            <span className="hero-stat-label">Board</span>
          </div>
          <div className="hero-stat">
            <div className="hero-stat-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="8.5" cy="7" r="4"/><path d="M20 8v6M23 11h-6"/></svg>
            </div>
            <span className="hero-stat-value">${formatUSDTRaw(directIncome)}</span>
            <span className="hero-stat-label">Direct</span>
          </div>
          <div className="hero-stat">
            <div className="hero-stat-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 20V10M18 20V4M6 20v-4"/></svg>
            </div>
            <span className="hero-stat-value">${formatUSDTRaw(levelIncome)}</span>
            <span className="hero-stat-label">Level</span>
          </div>
        </div>
        {usdtBalance && (
          <div className="hero-balance">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="4" width="22" height="16" rx="2"/><path d="M1 10h22"/></svg>
            <span>Balance: <strong>${formatUSDTRaw(usdtBalance)} USDT</strong></span>
          </div>
        )}
      </div>
    </div>
  );
}
